import createImage from 'src/core/CoreFilePicker/functions/createImage'
import { MIME_TYPE_IMAGE_PREFIX } from 'www/constants/fileTypes'
import { FileValidationRule, ImageValidationRule } from 'src/core/CoreFilePicker/types'

export default function useValidate() {
  function validateFile(file: File, rules?: FileValidationRule[]) {
    if (!rules) {
      return true
    }

    const failedRule = rules.find(
      rule => rule.validate(file) !== true,
    )

    return failedRule ? failedRule.error : true
  }

  async function validateImage(file: File, rules?: ImageValidationRule[]) {
    // Дополнительно проверяем относится ли файл к изображениям (имеет MIME-тип 'image/*'),
    // если нет, то createImage упадёт с ошибкой.
    if (!rules || file.type.indexOf(MIME_TYPE_IMAGE_PREFIX) !== 0) {
      return true
    }

    const objectUrl = URL.createObjectURL(file)
    const image = await createImage(objectUrl)
      .finally(() => {
        URL.revokeObjectURL(objectUrl)
      })

    const failedRule = rules.find(
      rule => rule.validate(image) !== true,
    )

    return failedRule ? failedRule.error : true
  }

  return {
    validateFile,
    validateImage,
  }
}
